import type { PackageEstimateRange, PackageEstimates } from '@openx/types/package';

export const isEstimateEmpty = (estimate?: PackageEstimateRange | null) =>
  !estimate || (estimate.low === '' && estimate.high === '');

export const wholeEstimatesEmpty = (estimates?: PackageEstimates | null): boolean =>
  !estimates ||
  (isEstimateEmpty(estimates.cpm) && isEstimateEmpty(estimates.reach) && isEstimateEmpty(estimates.market_requests));
